export default {
  mapView: {
    polylineMeasure: {
      unitControlLabel: {
        feet: 'ft',
        landmiles: 'M',
        nauticalmiles: 'NM',
        kilometres: 'km',
        metres: 'm',
      },
      bearingTextIn: 'În',
      bearingTextOut: 'Afară',
      tooltipTextDragAndDelete: 'Faceți clic și trageți pentru <b>punct de deplasare</b><br>Apăsați tasta SHIFT și faceți clic pentru <b>punctul de ștergere</b>',
      tooltipTextResume: '<br>Apăsați tasta CTRL și faceți clic pentru <b>linia de reluare</b>',
      tooltipTextAdd: 'Apăsați tasta CTRL și faceți clic pentru a <b>adăuga un punct</b>',
      measureControlTitleOff: 'Activați măsurarea distanței',
      unitControlTitle: {
        text: 'Schimbarea unităților',
        metres: 'metri',
        landmiles: 'mile de teren',
        nauticalmiles: 'mile nautice',
      },
      clearControlLabel: '&ori',
      measureControlLabel: '&#8614;',
      tooltipTextDelete: 'Apăsați tasta SHIFT și faceți clic pentru a <b>șterge punctul</b>',
      clearControlTitle: 'Măsurători clare',
      measureControlTitleOn: 'Activați măsurarea distanței',
    },
    youCantIntersectPolygons: 'Nu se pot intersecta poligoane',
    polygonArea: 'Zona poligonală',
    highlighting: 'Evidențierea',
    accuracy: 'Precizie',
    yourLocation: 'Utilizați locația dvs',
    viewOnORS: 'Vezi pe ORS',
    moveMapPositionToLeft: 'Mutați centrul hărții spre stânga',
    moveMapPositionToUp: 'Mutați centrul hărții în sus',
    moveMapPositionToDown: 'Mutați centrul hărții în jos',
    toggleDirect: 'Comutați direct de aici până la următorul loc',
    heightGraph: {
      distance: 'Distanță',
      elevation: 'Elevație',
      segment_length: 'Lungimea segmentului',
      type: 'Tip',
      legend: 'Legenda',
    },
    editShape: 'Editați forma',
    remove: 'Eliminați',
    avoidPolygonSaved: 'Evitați poligonul salvat',
    avoidPolygonNotRemoved: 'Nu a fost posibil să se elimine poligonul de evitare',
    avoidPolygonNotSaved: 'Nu a fost posibilă salvarea poligonului de evitare',
    customTileProvider: 'Furnizor de țiglă personalizat definit de utilizator',
    gestureHandling: {
      touch: 'Folosiți două degete pentru a muta harta',
      scroll: 'Utilizați ctrl + scroll pentru a mări harta',
      scrollMac: 'Utilizați ⌘ + scroll pentru a mări harta',
    },
    defineAvoidPolygon: 'Definirea poligoanelor de evitare pentru calculul traseului',
    defineAvoidRectangle: 'Definirea dreptunghiurilor de evitare pentru calculul traseului',
    youCanCenterAtYourLocationLater: 'Puteți centra harta pe locația dvs. curentă în orice moment, făcând clic pe butonul "locația mea"',
    setMyLocationAsMapCenter: 'Doriți să centrați harta la locația dvs. curentă? Acest lucru va îmbunătăți precizia căutării unui loc. Va trebui să autorizați acest lucru dacă vi se solicită.',
    removePlace: 'Scoateți locul',
    moveMapPositionToRight: 'Mutați centrul hărții spre dreapta',
    avoidPolygonRemoved: 'Evitați poligonul eliminat',
    polygonEditModeEnabled: 'Când terminați editarea, faceți clic oriunde pentru a salva modificările',
    routeTo: 'Ruta către acest loc',
    polygon: 'Poligon',
    whatIsHere: 'Ce este aici ?',
    fitAllFeatures: 'Afișați toate funcțiile',
    addRouteStop: 'Adăugați o oprire pe traseu aici',
    addDestinationToRoute: 'Adăugarea destinației la traseu',
    acquirePositionErrors: {
      unavailable: 'Conform dispozitivului dumneavoastră, locația nu este disponibilă în prezent. Asigurați-vă că opțiunea/serviciul de poziționare este configurat(ă) corect.',
      timeout: 'Dispozitivul dumneavoastră a returnat "timeout" în timp ce încerca să obțină o poziție. Puteți încerca din nou făcând clic pe "butonul poziția mea"',
      generic: 'Nu a fost posibilă obținerea locației dumneavoastră deoarece nu a fost autorizată sau deoarece dispozitivul nu o acceptă.',
      permissionDenied: 'Poziția dumneavoastră nu a putut fi obținută deoarece dispozitivul a refuzat accesul la ea. Puteți încerca din nou modificând setările dispozitivului și apoi faceți din nou clic pe "butonul poziția mea"',
    },
    yourCurrentLocation: 'Locația dumneavoastră actuală',
    options: 'Opțiuni',
    polygonDetails: 'Detalii poligon',
    directionsFromHere: 'Direcții de aici',
  }
}
